import { render, staticRenderFns } from "./PermissionsWrapper.vue?vue&type=template&id=275fea1b&scoped=true&"
import script from "./PermissionsWrapper.vue?vue&type=script&lang=ts&"
export * from "./PermissionsWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsWrapper.vue?vue&type=style&index=0&id=275fea1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_babel-core@7.0.0-bridge.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.44.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275fea1b",
  null
  
)

export default component.exports